export var acknowledgement = function acknowledgement(centralApi) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = null;
      }
      return centralApi.get('/acknowledgement', {
        params: params
      });
    },
    history: {
      index: function index(params) {
        if (params === void 0) {
          params = null;
        }
        return centralApi.get('/acknowledgement/history', {
          params: params
        });
      }
    }
  };
};